export default __webpack_public_path__ + "static/media/icn-edit-pen.b48d2e1b.svg";